import { useMemoizedUuid } from './useMemoizedUuid';

/**
 * Returns either the supplied `idOverride` if defined, or a stable generated id
 * that does not change across renders.
 *
 * Mirrors `@mui/utils/useId` so MUI-derived components can be ported with
 * minimal changes.
 */
export const useId = (idOverride?: string): string => {
  const generatedId = useMemoizedUuid();
  return idOverride ?? `nucleus-${generatedId}`;
};
